import DialpadButton from './DialpadButton';

export default DialpadButton;
